import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { ActiveDealState } from './types';

export const getInitialActiveDealState = (): ActiveDealState => ({
    details: null,
    isInitializing: true,
    updateDealStatus: ApiRequestStatus.Idle
});
